import { getCalendarInstanceKeyItemIdIndex } from '../../store/store';

/**
 * Gets all itemIds for the given instanceKey.
 * @param instanceKey - CalendarInstanceKey.
 * @returns Array of item Ids.
 */
export default function getItemIdsByInstanceKeyFromCache(instanceKey: string): string[] {
    return getCalendarInstanceKeyItemIdIndex().getAllItemIds(instanceKey);
}
